module.exports = __webpack_public_path__ + "media/images/payment/multibanco-b0158db1a2d807ba1f93c572ef783fec.svg";